import { BeatLoader} from "react-spinners";

function CardConsumos({ title, value, loading }) {
    return (
        <div className="flex flex-col justify-between items-center flex-1 min-w-[160px] bg-white rounded-2xl shadow p-4 text-center">
            <p className="text-gray-600 text-sm leading-tight">{title}</p>
            {loading ?
                <div style={{ display: "flex", justifyContent: "center" }}><BeatLoader color="#B04708" loading={loading} speedMultiplier="0.5" /></div> :
                <p className="text-black font-semibold text-3xl">{value}</p>
            }
        </div>
    );
}

export default CardConsumos;